export class DatabrowsingOptions {
    useAsComponent: boolean;
    urlForDataTable: string;
    urlForTableContent: DownloadMediaTypes;
    defaultEntityViewId: string;
    visibleEntities: string[];
}

export enum DownloadMediaTypes {
    DATA = 'data'
}

export const ATTRIBUTE_COUNTER_SUFFIX = '.length';
